module.exports = __webpack_public_path__ + "static/media/03-Banque-Mondiale.99748483.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_banque-mondiale/03-Banque-Mondiale.jpg
// module id = 1182
// module chunks = 37